window.PredictiveSearchShared = window.PredictiveSearchShared || {
  fields: 'title,product_type,variants.title,vendor,variants.sku',
  limit: 10,

  buildSuggestUrl: function(term, sectionId, resourceTypes) {
    var types = resourceTypes || 'product';
    return routes.predictive_search_url +
      '?resources[type]=' + encodeURIComponent(types) +
      '&q=' + encodeURIComponent(term) +
      '&resources[limit]=' + this.limit +
      '&resources[options][fields]=' + encodeURIComponent(this.fields) +
      '&section_id=' + encodeURIComponent(sectionId);
  }
};
